import React from 'react';
import PaymentComplete from "./PaymentComplete";

const CompletePaymentFlows = () => {
  // only base complete payment flow for now
  return (
    <PaymentComplete/>
  )
};

export default CompletePaymentFlows;
